module.exports = __webpack_public_path__ + "static/media/Thought-leaders-hero.4f9cbaad.jpg";